import React from "react";
import { Text } from "@bookingcom/bui-react";
import { useFranceTaxController } from "./useFranceTax.controller";

export function FranceTax() {
  const { canRender, text } = useFranceTaxController();
  return canRender ? (
    <Text variant="small_1" color="neutral_alt">
      {text}
    </Text>
  ) : null;
}
